var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cookie-bar",
      class: {
        out: !_vm.isVisible,
        "border-top bg-white": _vm.isVisible,
        "fixed-bottom": !_vm.isShopBuilder || false
      }
    },
    [
      _vm.isVisible
        ? _c("div", { staticClass: "container-max" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isExpanded,
                    expression: "!isExpanded"
                  }
                ],
                staticClass: "row py-3",
                class: _vm.classes,
                style: _vm.styles
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "cookie-bar__headline" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate(
                            "ODKleinMore::Template.cookieBarHeadline"
                          )
                        ) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "cookie-bar__text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate("ODKleinMore::Template.cookieBarText")
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-lg-6" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-block btn-appearance",
                          on: {
                            click: function($event) {
                              _vm.acceptAll()
                              _vm.close()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "  " +
                              _vm._s(
                                _vm.$translate(
                                  "ODKleinMore::Template.cookieBarButton1"
                                )
                              )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-lg-6 mt-2 mt-lg-0" }, [
                      _vm.showRejectAll
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-block btn-appearance",
                              attrs: { "data-testing": "cookie-bar-deny-all" },
                              on: {
                                click: function($event) {
                                  _vm.denyAll()
                                  _vm.close()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.cookieBarDenyAll"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "cookie-bar__button--2",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.isExpanded = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ODKleinMore::Template.cookieBarButton2"
                          )
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 cookie-bar__image" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/0fzvjq1iz403/frontend/KM_Logo.png",
                      alt: "Logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "cookie-bar__info",
                    domProps: { innerHTML: _vm._s(_vm.text) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _vm.isExpanded
              ? _c(
                  "div",
                  {
                    staticClass: "row py-3",
                    class: _vm.classes,
                    style: _vm.styles
                  },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-primary text-appearance d-inline-block mb-3",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.isExpanded = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.cookieBarBack")
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-3" },
                      [
                        _c("privacy-settings", {
                          attrs: { "consent-groups": _vm.consentGroups }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-block btn-primary btn-appearance",
                          on: {
                            click: function($event) {
                              _vm.acceptAll()
                              _vm.close()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODKleinMore::Template.cookieBarButton1"
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _vm.showRejectAll
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-block btn-appearance mt-2",
                              attrs: { "data-testing": "cookie-bar-deny-all" },
                              on: {
                                click: function($event) {
                                  _vm.denyAll()
                                  _vm.close()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.cookieBarDenyAll"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 " }, [
                      _c(
                        "button",
                        {
                          staticClass: "cookie-bar__button--2",
                          on: {
                            click: function($event) {
                              _vm.storeConsents()
                              _vm.close()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "ODKleinMore::Template.cookieBarButton3"
                              )
                            )
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-appearance",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.isCollapsed = false
                  }
                }
              },
              [
                _c("span", { staticClass: "d-none d-sm-inline-block" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.cookieBarPrivacySettings")
                    )
                  )
                ])
              ]
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }